import ReactGA from "react-ga4";

export const reactGaEvent = (category, action) => {
    ReactGA.event({
        category: category,
        action: action
    });
};